import { render, staticRenderFns } from "./SaveFile.vue?vue&type=template&id=fed06e80"
import script from "./SaveFile.vue?vue&type=script&lang=js"
export * from "./SaveFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports